<template>
  <DxPopup
    :visible.sync="localShowPopup"
    :drag-enabled="true"
    :close-on-outside-click="true"
    :show-title="true"
    :width="1280"
    :height="450"
    :title="'Reviews for #' + rowId"
  >
    <div>
      <dx-data-grid
        :data-source="reviews"
        :show-borders="true"
        :key-expr="'rowReview.id'"
        :remote-operations="false"
        :allow-column-reordering="false"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        :hover-state-enabled="true"
        :word-wrap-enabled="true"
        :column-auto-width="true"
        :show-row-lines="true"
        :show-column-lines="true"
        class="dx-card wide-card"
        width="100%"
      >
        <dx-column-chooser :enabled="false" />
        <dx-export
          :enabled="true"
          :file-name="`${currentDate}-reviews-{{showReviewsData.row.id}}`"
        />
        <dx-column data-field="rowReview.id" />
        <dx-column
          data-field="review.created"
          data-type="datetime"
          :format="config.intlDateTimeFormat"
          caption="Review Opened"
        />
        <dx-column
          data-field="review.userIdCreated"
          :lookup="userColumnLookup"
          caption="Opened By"
        />
        <dx-column data-field="review.comment" caption="Open Comment" />
        <dx-column
          data-field="closed.timestamp"
          data-type="datetime"
          :format="config.intlDateTimeFormat"
          caption="Review Closed"
        />
        <dx-column
          data-field="closed.userIdClosed"
          :lookup="userColumnLookup"
          caption="Closed By"
        />
        <dx-column data-field="closed.comment" caption="Close Comment" />
      </dx-data-grid>
    </div>
  </DxPopup>
</template>

<script>
import { mapState } from 'vuex'
import { config } from '@/config'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxExport,
} from 'devextreme-vue/data-grid'
import { DxPopup } from 'devextreme-vue/popup'

export default {
  name: 'ReviewsPopup',
  components: {
    DxColumn,
    DxColumnChooser,
    DxDataGrid,
    DxExport,
    DxPopup,
  },
  props: {
    rowId: { type: Number, required: true },
    reviews: { type: Array, required: true },
    showPopup: { type: Boolean, required: true },
  },
  data() {
    return {
      config,
    }
  },
  computed: {
    ...mapState('user', ['userColumnLookup']),
    currentDate() {
      return new Date().toISOString().split('T')[0]
    },
    localShowPopup: {
      get() {
        return this.showPopup
      },
      set(v) {
        this.$emit('update:showPopup', v)
      },
    },
  },
}
</script>

<style lang="scss"></style>
